L.Control.Legend = L.Control.extend({
  options: {
    position: 'topleft',
    controlButton: {
      title: "Legend"
    }
  },

  onRemove: function(map) {
    this._container = null
  },

  onAdd: function (map) {
    this._map = map
    let container = this._container = L.DomUtil.create('div', 'leaflet-control-legend legend-container')
    this._initToggle()

    return container
  },

  _initToggle: function() {

    let container = this._container

    let link = this._button = L.DomUtil.create('a', " legend-toggle", container)
    L.DomUtil.create('i', "Icon IconLegend", link)
    link.href = '#'
    link.title = this.options.controlButton.title
    L.DomEvent
      .on(link, 'click', this._toggle, this)
    L.DomEvent
      .on(link, 'click', L.DomEvent.stop)
    this._map.on('click', this._collapse, this)
    this._collapse()
  },

  _toggle: function() {
    if (this._container.classList.contains('legend-collapsed')) {
      this._expand()
    } else {
      this._collapse()
    }
  },

  _expand: function() {
    this._container.className = this._container.className.replace('legend-collapsed', '')
  },

  _collapse: function() {
    L.DomUtil.addClass(this._container, 'legend-collapsed')
  },
})

L.control.legend = function(options) {
  return new L.Control.Legend(options)
}



// WEBPACK FOOTER //
// ./src/helpers/leaflet-legend.js